import { IOptionItem } from "@/components/ui/dropdown/types";

const DropdownListCoverage = (option: IOptionItem) => (
  <div className="flex flex-col gap-0.5">
    <span className="text-[13px] font-semibold text-txtHeading">
      {option.label}
    </span>
    {option.description && (
      <span className="text-[11px] text-txtBody whitespace-pre-line">
        {option.description}
      </span>
    )}
  </div>
);
export default DropdownListCoverage;
